import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ReBaseData } from '../../../shared/utils/re-base-data';
import { TRACKING } from '../../enums/trackingParts.enum';
import { TrackingService } from '../../services/tracking.service';

@Component({
    selector: 'bdo-logout-success',
    templateUrl: './logout-success.component.html',
    styleUrls: ['./logout-success.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LogoutSuccessComponent implements OnInit {
  public TRACKING = TRACKING;

  protected reBaseData = ReBaseData;

  constructor(
    private trackingService: TrackingService
  ) { }

  ngOnInit() {
    this.trackingService.postTracking(TRACKING.LOCATION.LOGOUT_SUCCESS, TRACKING.ACTION.ENTER);
  }

  goToMainPage() {
    this.trackingService.postTracking(TRACKING.LOCATION.LOGOUT_SUCCESS, TRACKING.ACTION.GOTO, TRACKING.LOCATION.HOMEPAGE);
  }
}
